module.exports = __webpack_public_path__ + "static/media/exceptionalATeamer.b85dd450.svg";